import React from "react";
import "./footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { IoLogoTwitter } from "react-icons/io5";

function Footer() {
  return (
    <footer>
      <a href="#home" className="footer__logo">
        AACoder
      </a>
      <ul className="permalinks">
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a href="https://www.facebook.com/ali.ammari.9465/">
          <FaFacebookF />
        </a>
        <a href="https://www.linkedin.com/in/aliammari68/">
          <FaLinkedinIn />
        </a>
        <a href="https://twitter.com/aliammari862">
          <IoLogoTwitter />
        </a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Ali Ammari. All rights reserved</small>
      </div>
    </footer>
  );
}

export default Footer;
